import React from 'react';
import { useTranslation } from 'react-i18next';

import { Ul, Li } from './StyledElement';

export const Header: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Ul isHeader={true}>
      <Li width="100">{t('models.user.lastName')}</Li>
      <Li width="100" narrowMargin={true}>
        {t('models.user.firstName')}
      </Li>
      <Li width="100" narrowMargin={true}>
        {t('models.user.kanaLastName')}
      </Li>
      <Li width="100" narrowMargin={true}>
        {t('models.user.kanaFirstName')}
      </Li>
      <Li width="200">{t('models.user.email')}</Li>
      <Li width="156">{t('models.user.nameId')}</Li>
      <Li width="24" />
    </Ul>
  );
};
